// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

//enums
// eslint-disable-next-line no-unused-vars
import { PayType } from "@/enums/payType";
// eslint-disable-next-line no-unused-vars
import { PaymentType } from "@/enums/paymentType";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## PaymentMethod Get
/**
 *
 * @param {{params: object, query: { payType: PayType, paymentType:PaymentType }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.PaymentMethod.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## PaymentMethod Create
/**
 *
 * @param {{"paymentType": PaymentType,"payType": PayType}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.PaymentMethod.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PaymentMethod Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.PaymentMethod.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PaymentMethod Update
/**
 *
 * @param {{"paymentType": "Cash","payType": "WithKdv", isActive: boolean}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.PaymentMethod.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PaymentMethod Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.PaymentMethod.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
